import React from 'react';
import Strapi from 'strapi-sdk-javascript';

const apiUrl = process.env.API_URL || 'http://localhost:1337';
const strapi = new Strapi(apiUrl);

const Home = ()=>{

    const [items, setItems]= React.useState([]);

  async function Fetchy(){
    
    try{

      const res = await strapi.request('POST', '/graphql', {
        data:{
          query: `query{
            items{
              _id
              name
              holdsize
              description
              quantity
              image{
                url
              }
            }
          }`
        }
      });
  
      console.log(res)
      setItems(res.data.items)
      
    }
    catch(err){
      console.log(err)
    }

  }

  React.useEffect(()=>{
   Fetchy();
  },[])
    return(
        <div>
            <h1>welcome to the home page</h1>
            <h2>Featured Items</h2>
                <div className="Heading">
                    <div className="Items">
                    {items.map((it,index)=>(
                        <div key={index} className="card">
                        <img  src = {`${apiUrl}${it.image[0].url}`} alt="yeet" />
                        <div className="infoHold">
                            <h1>{it.name}</h1>
                            <h3>quantity: {it.quantity}</h3>
                            <h3>size: {it.holdsize}mm</h3>
                            <p>{it.description}</p>
                        </div>
                        </div>
                    ))}
                    </div>
                </div>
        </div>
    );
}
export default Home;